import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import stylesPc from "./UploadVideo.module.css";
import stylesSp from "./UploadVideo_SP.module.css";
import styleIpad from "./UploadVideo_IP.module.css";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Modal from "@material-ui/core/Modal";
import SelectTag from "./SelectTag";
import {
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    createStyles,
    createTheme,
    makeStyles,
    ThemeProvider,
} from "@material-ui/core";
import { GetGroupList, GetUserInfoList } from "../../user/UserActions";
import { AppState } from "../../root/RootReducer";
import {
    AddVideo,
    DeleteMediaRecorderVideoFile,
    ResetDuplicateError,
} from "../../common/video/VideoActions";
import UploadDocument from "../../pages/vod/Common/UploadDocument";
import { countCharLength } from "../../utils/ValidationUtils";
import PuiMessage from "../../components/widgets/PuiMessage";
import SelectGroup from "../../pages/admin/EditUser/SelectGroup";
import { Group } from "../../user/User";
import { ExtractFileName, GetTagIdFromTagName, processLanguage } from "../../utils/ObjectUtils";
import { IsDevice } from "../../components/function/useDeviceFlag";
import PuiTypography from "../../components/elements/PuiTypography";
import CustomTimelineSetting from "../../studio/components/editTimeline/CustomTimelineSetting";
import { ArrowBackIos, Check } from "@material-ui/icons";
import { RESOLUTION, Bitrate, Resolution, FrameRate } from "../../studio/models/video";
import { UpdateExportVideoInfo } from "../../studio/store/actions/VideoInfoActions";
import { t } from "i18next";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface UploadVideoProps {
    setIsSaved: (isSaved: boolean) => void;
    isSaved: boolean;
    closeUploadModal?: () => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        title: {
            width: IsDevice("iphone") ? "100%" : "440px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontWeight: "bold",
            "& .MuiInputBase-root": {
                height: "40px",
                "& .MuiInputBase-input": {
                    border: "none",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
        formSelect: {
            border: "1px solid rgba(255, 255, 255, 0.3)",
            width: IsDevice("iphone") ? "100%" : "440px",
            height: "40px",
            fontSize: "14px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontFamily: "Yu Gothic",
            "& .MuiSelect-icon": {
                color: "white",
            },
            "& .MuiSelect-selectMenu": {
                color: "white",
            },
        },
        menuItem: {
            backgroundColor: "var(--textfield-bg)",
            color: "white",
            "&:hover": {
                color: "white",
                backgroundColor: "#35393F",
            },
            // "& .MuiButtonBase-root": {
            //     color: "rgba(1, 1, 1, 0.5)",
            // },
        },
        checkBox: {
            color: "white",
        },
        dropdownStyle: {
            color: "white",
            backgroundColor: "var(--textfield-bg)",
        },
        icon: {
            marginLeft: "5px",
            marginTop: "5px",
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            "&:hover": {
                backgroundColor: "rgb(255, 255, 255, 0.9)",
            },
        },
        textField: {
            width: IsDevice("iphone") ? "100%" : "440px",
            minHeight: IsDevice("iphone") ? "none" : "200px",
            overflowY: "auto",
            background: "#FFFFFF0D",
            border: "none",
            borderRadius: "5px",
            "& .MuiInputBase-root": {
                minHeight: "200px",
                "& .MuiInputBase-input": {
                    height: "163px !important",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
    })
);

// const defaultGroup: Group[] = [
//     {
//         id: "1",
//         title: "pactera",
//         description: "pactera group",
//         userList: [],
//         videoList: [],
//     },
// ];

const theme = createTheme({
    palette: {
        secondary: {
            main: "#16ADC1",
        },
    },
});

export default function UploadVideo({ setIsSaved, isSaved, closeUploadModal }: UploadVideoProps) {
    const classes = useStyles();

    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    // ユーザー取得
    const {
        professionals,
        isLoading,
        tags,
        mediaRecorderVideoFile,
        groupList,
        videoBitrate,
        videoWidth,
        videoHeight,
        exportVideoInfo,
    } = useSelector((state: AppState) => ({
        professionals: state.user.userInfoList,
        isLoading: state.user.isLoading,
        tags: state.video.tags,
        mediaRecorderVideoFile: state.video.mediaRecorderVideoFile,
        groupList: state.user.groupList,
        videoBitrate: state.videoInfo.exportVideoInfo.bitrate,
        videoWidth: state.videoInfo.exportVideoInfo.width,
        videoHeight: state.videoInfo.exportVideoInfo.height,
        exportVideoInfo: state.videoInfo.exportVideoInfo,
    }));

    const dispatch = useDispatch();
    const inputVideoRef = useRef<HTMLInputElement>(null);
    const inputImageRef = useRef<HTMLInputElement>(null);

    // タグ選択モーダル画面
    const [tagList, setTagList] = React.useState<string[]>([]);

    const [languageJa, setLanguageJa] = React.useState(false);
    const handleChangeLanguageJa = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLanguageJa(event.target.checked);
    };
    const [languageEn, setLanguageEn] = React.useState(false);
    const handleChangeLanguageEn = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLanguageEn(event.target.checked);
    };
    const [languageZh, setLanguageZh] = React.useState(false);
    const handleChangeLanguageZh = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLanguageZh(event.target.checked);
    };
    const [languageVi, setLanguageVi] = React.useState(false);
    const handleChangeLanguageVi = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLanguageVi(event.target.checked);
    };

    //APIコール
    useEffect(() => {
        dispatch(GetUserInfoList());
        if (groupList && groupList.length === 0) {
            dispatch(GetGroupList());
        }
        // eslint-disable-next-line
    }, [dispatch]);

    const [inputVideoFile, InputVideoFile] = useState<File | null>(null);
    const [inputVideoFileName, InputVideoFileName] = useState("");
    const [inputVideoName, InputVideoName] = useState("");
    const [inputLanguage, setInputLanguage] = useState("");
    const [visiblePreviewImage, ChangevisiblePreviewImage] = useState(false);
    const [inputImageFile, InputImageFile] = useState(null);
    const [inputVideoProfessional, InputVideoProfessional] = useState("-1");
    const [inputVideoDetail, InputVideoDetail] = useState("");

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);

    //Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    //アップロード動画の言語選択時の処理
    // const changeInputLang = (event: any) => {
    //     setInputLanguage(event.target.value);
    //     setLanguageJa(false);
    //     setLanguageEn(false);
    //     setLanguageZh(false);
    //     setLanguageVi(false);
    //     if (event.target.value === "ja-JP") {
    //         setLanguageJa(true);
    //     } else if (event.target.value === "en-US") {
    //         setLanguageEn(true);
    //     } else if (event.target.value === "zh-CN") {
    //         setLanguageZh(true);
    //     } else if (event.target.value === "vi-VN") {
    //         setLanguageVi(true);
    //     }
    // };

    //言語チェックボックスの初期化を一度だけコール
    //ここでアップロード動画の言語を指定しても反映されないため、手動で操作
    useEffect(() => {
        setInputLanguage("ja-JP");
        setLanguageJa(true);
    }, []);

    const UserInputVideoFile = (event: any) => {
        InputVideoFile(event.target.files[0]);
        InputVideoFileName(event.target.files[0].name);
        InputVideoName(ExtractFileName(event.target.files[0].name));
        setIsSaved(false);
    };

    // 動画スクリーンキャプチャで生成した動画ファイルを保存する
    const SetMediaRecorderVideoFile = (file: File) => {
        InputVideoFile(file);
        // InputVideoFileName(new Date().getTime() + ".mp4");
        InputVideoFileName(file.name);
        InputVideoName(ExtractFileName(file.name));
        ChangeTextUploadVideo(file.name);
        setIsSaved(false);
    };

    const UserInputVideoName = (event: any) => {
        InputVideoName(event.target.value);
        setIsSaved(false);
    };
    const UserInputImageFile = (event: any) => {
        InputImageFile(event.target.files[0]);
        setIsSaved(false);
    };
    const UserInputVideoProfessional = (event: any) => {
        InputVideoProfessional(event.target.value);
        setIsSaved(false);
    };
    const UserInputVideoDescription = (event: any) => {
        InputVideoDetail(event.target.value);
        setIsSaved(false);
    };

    // ビデオタイトルチェック
    const [isErrorTitleValidation, CheckTitleValidation] = useState(false);
    const ChangeTitle = (event: any) => {
        if (countCharLength(event.target.value) > 80) {
            UserInputVideoName(event);
            CheckTitleValidation(true);
        } else {
            CheckTitleValidation(false);
            UserInputVideoName(event);
        }
        setIsSaved(false);
    };

    //ビデオ要約チェック
    const [isErrorDescriptionValidation, CheckDescriptionValidation] = useState(false);
    const ChangeDescription = (event: any) => {
        if (countCharLength(event.target.value) > 600) {
            UserInputVideoDescription(event);
            CheckDescriptionValidation(true);
        } else {
            CheckDescriptionValidation(false);
            UserInputVideoDescription(event);
        }
        setIsSaved(false);
    };

    // 資料アップロード
    const [inputDocumentList, ChangeDocumentList] = useState<File[]>([]);
    const [inputDocumentNameList, ChangeDocumentNameList] = useState<string[]>([]);
    const [isErrorDocumentListLength, ErrorDocumentListLength] = useState(false);

    // ビデオファイルアップロードテキスト
    const [textUploadVideo, ChangeTextUploadVideo] = useState(
        t("アップロードするファイルを選択（1GBまで）")
    );
    const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);
    const UserUploadVideo = (event: any) => {
        if (event.target.files.length === 0) {
            ChangeTextUploadVideo(t("アップロードするファイルを選択（1GBまで）"));
            InputVideoFile(null);
            InputVideoFileName("");
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 1073741824) {
                    ChangeLimitInputFileSize(true);
                    if (inputVideoRef.current) {
                        inputVideoRef.current.value = "";
                    }
                } else {
                    UserInputVideoFile(event);
                    ChangeTextUploadVideo(event.target.files[0].name);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputVideoRef.current) {
                    inputVideoRef.current.value = "";
                }
            }
        } else {
            ChangeTextUploadVideo(t("ファイルを正しく選択してください（1GBまで）"));
            InputVideoFile(null);
            InputVideoFileName("");
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
        }
        setIsSaved(false);
    };

    // ファイルサイズ制限バー消去
    const CloseLimitInputFileBar = () => {
        ChangeLimitInputFileSize(false);
    };

    // 画像ファイルアップロードテキスト
    const [textUploadImage, ChangeTextUploadImage] = useState(
        t("ビデオサムネイル用のファイルを選択")
    );
    const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);
    const UserUploadImage = (event: any) => {
        if (event.target.files.length === 0) {
            ChangevisiblePreviewImage(false);
            ChangeTextUploadImage(t("ビデオサムネイル用のファイルを選択"));
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 10485760) {
                    ChangeLimitInputImageSize(true);
                    if (inputImageRef.current) {
                        inputImageRef.current.value = "";
                    }
                } else {
                    UserInputImageFile(event);
                    ChangeTextUploadImage(event.target.files[0].name);
                    InputImageFile(event.target.files[0]);
                    ChangevisiblePreviewImage(true);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        } else {
            ChangevisiblePreviewImage(false);
            ChangeTextUploadImage(t("ファイルを正しく選択してください"));
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        }
        setIsSaved(false);
    };

    // サムネイルサイズ制限バー消去
    const CloseLimitInputImageBar = () => {
        ChangeLimitInputImageSize(false);
    };

    // ユーザのプレビュー画像クリックで、テキスト表示に戻す
    const ClickPreviewImage = (event: any) => {
        ChangeTextUploadImage(t("ビデオサムネイル用のファイルを選択（1GBまで）"));
        InputImageFile(null);
        ChangevisiblePreviewImage(false);
        setIsSaved(false);
    };

    // タグ選択モーダル画面表示制御
    const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
        dispatch(ResetDuplicateError());
    };

    const handleDelete = (tagName: string) => () => {
        setTagList((tagList) => tagList.filter((v) => v !== tagName));
        setIsSaved(false);
    };

    // グループ選択モーダル画面表示制御
    const [isOpenGroupSelectModal, ShowGroupSelectModal] = useState(false);
    const [group, setGroup] = useState<Group[]>([]);
    // const [defaultGroup, setDefaultGroup] = useState<UpdateGroup[]>();

    const CloseGroupSelectModal = () => {
        ShowGroupSelectModal(false);
        // ChangeEditUserGroup([]);
    };
    const SetVideoGroup = (updateGroupList: Group[]) => {
        // const changeIndex = userData.findIndex(({id}) => id === editUserId);
        // userData[changeIndex]["group"] = updateGroupList;
        setGroup(updateGroupList);
        setIsSaved(false);
    };

    // グループ選択
    const UserInputVideoGroup = (event: any) => {
        const groupNames: string[] = event.target.value;
        if (groupNames.includes("選択なし")) groupNames.splice(0, 1);
        const tempGroups: Group[] = [];
        groupList.forEach((group) => {
            if (groupNames.includes(group.title)) {
                tempGroups.push(group);
            }
        });
        setGroup(tempGroups);
        setIsSaved(false);
    };

    const [resolutionType, changeResolutionType] = useState<string>(RESOLUTION[1]);
    // 設定ボタンを押下の場合、モーダル表示定義
    const [openUploadVideoModal, setOpenUploadVideoModal] = useState(false);
    //custom判定
    const [openCustom, setOpenCustom] = useState<boolean>(false);
    //解像度選択表示判定
    const [openVideoResolutionSelect, setOpenVideoResolutionSelect] = useState<boolean>(false);
    //フレームレート選択表示判定
    const [openVideoFramerateSelect, setOpenVideoFramerateSelect] = useState<boolean>(false);
    //ビットレート選択表示判定
    const [openVideoBitrateSelect, setOpenVideoBitrateSelect] = useState<boolean>(false);
    //設定でカスタムか判定
    const [isCustom, setIsCustom] = useState<boolean>(false);

    //解像度選択
    const [bitrate, setbitrate] = useState<string>(Bitrate[1]);
    const [videoFramerate, setvideoFramerate] = useState<string>(FrameRate[1]);
    const [width, setWidth] = useState<string>("1270");
    const [height, setHeight] = useState<string>("720");

    // ビットレート
    const selectBitRate = (bitrate: string) => {
        setIsCustom(true);
        setbitrate(bitrate);
        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                bitrate: Number(bitrate),
            })
        );
    };

    // 解像度
    const selectResolution = (resolution: string) => {
        setIsCustom(true);
        const resolutionValue = resolution.split("×");
        setWidth(resolutionValue[0]);
        setHeight(resolutionValue[1]);
        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                width: Number(resolutionValue[0]),
                height: Number(resolutionValue[1]),
            })
        );
    };

    // フレームレート
    const selectvideoFrameRate = (framerate: string) => {
        setIsCustom(true);
        setvideoFramerate(framerate);
        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                framerate: Number(framerate),
            })
        );
    };

    const CloseCustom = () => {
        setOpenCustom(false);
        setOpenVideoBitrateSelect(false);
        setOpenVideoResolutionSelect(false);
        setOpenVideoFramerateSelect(false);
    };

    // 設定
    const handleClickSetting = (isOpen: boolean) => {
        setOpenUploadVideoModal(isOpen);
        setOpenCustom(false);
    };

    const ChangeResolution = (
        bitrate: string,
        videoresolution: string,
        videoFramerate: string,
        type: string
    ) => {
        const resolutionValue = videoresolution.split("×");
        if (type !== "カスタム") {
            changeResolutionType(type);
        }
        if (type === "カスタム") {
            setOpenCustom(true);
        } else if (openCustom) {
            setOpenCustom(false);
        } else {
            setIsCustom(false);
        }
        setbitrate(bitrate);
        setWidth(resolutionValue[0]);
        setHeight(resolutionValue[1]);
        setvideoFramerate(videoFramerate);
    };

    // 入力内容をバックエンドに送信
    const UploadVideo = () => {
        if (
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            inputVideoProfessional !== "-1" &&
            inputVideoProfessional !== "" &&
            inputVideoFile !== null &&
            isErrorTitleValidation === false &&
            isErrorDescriptionValidation === false
        ) {
            dispatch(
                AddVideo({
                    file: inputVideoFile,
                    imageFile: inputImageFile,
                    documentFile: inputDocumentList,
                    documentName: inputDocumentNameList,
                    video: {
                        title: inputVideoName,
                        sttLanguage: inputLanguage,
                        description: inputVideoDetail,
                        presenter: inputVideoProfessional,
                        filename: inputVideoFileName,
                        tags: GetTagIdFromTagName(tagList, tags),
                        group: group.map((item) => Number(item.id)),
                        bitrate: Number(bitrate),
                        width: Number(width),
                        height: Number(height),
                        framerate: Number(videoFramerate),
                        language: processLanguage(languageJa, languageEn, languageZh, languageVi),
                    },
                })
            );
        }
        // 入力内容リセット
        ResetUserInput();
    };

    // 登録ボタンの有無効制御
    const [isReadyToUpdate, ChangeReadyToSendFlag] = useState(false);
    useEffect(() => {
        if (
            !isSaved &&
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            inputVideoProfessional !== "-1" &&
            inputVideoProfessional !== "" &&
            inputVideoFile !== null &&
            !isErrorTitleValidation &&
            !isErrorDescriptionValidation &&
            !isErrorDocumentListLength
        ) {
            ChangeReadyToSendFlag(false);
        } else {
            ChangeReadyToSendFlag(true);
        }
    }, [
        isSaved,
        inputVideoName,
        inputLanguage,
        inputVideoDetail,
        inputVideoProfessional,
        inputVideoFile,
        isErrorTitleValidation,
        isErrorDescriptionValidation,
        isErrorDocumentListLength,
    ]);

    useEffect(() => {
        if (!mediaRecorderVideoFile) return;
        SetMediaRecorderVideoFile(mediaRecorderVideoFile);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaRecorderVideoFile]);

    // 入力内容リセット
    const ResetUserInput = () => {
        ChangeTextUploadVideo(t("アップロードするファイルを選択（1GBまで）"));
        InputVideoFile(null);
        InputVideoFileName("");
        if (inputVideoRef.current) {
            inputVideoRef.current.value = "";
        }
        InputVideoName("");
        ChangevisiblePreviewImage(false);
        InputImageFile(null);
        ChangeTextUploadImage(t("Videoサムネイル用のファイルを選択"));
        if (inputImageRef.current) {
            inputImageRef.current.value = "";
        }
        InputVideoProfessional("-1");
        InputVideoDetail("");
        ChangeDocumentList([]);
        ChangeDocumentNameList([]);
        setTagList([]);
        setGroup([]);
        // setGroup(defaultGroup);
        setIsSaved(true);
        dispatch(DeleteMediaRecorderVideoFile());
    };

    // 表示待機
    if (isLoading) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <div className={styles.root}>
            <PuiTypography size={18} color={"white"}>
                {t("動画アップロード")}
            </PuiTypography>
            <ul className={styles.inputForm}>
                <FormControl className={styles.uploadForm}>
                    <form name="addVideoForm" id="addVideoForm">
                        {!IsDevice("desktop") && (
                            <div onClick={closeUploadModal} className={styles.closeButton}>
                                <img
                                    src={require("../../assets/image/closeFilter.svg").default}
                                    alt="close"
                                />
                            </div>
                        )}
                        {/* ビデオファイル */}
                        <li>
                            <div className={styles.formHelperText}> {t("動画ファイル")}</div>
                            <div className={styles.form}>
                                <label className={styles.uploadButton}>
                                    {/* ビデオアップロードのみ、PDF削除 */}
                                    <input
                                        id="browserVideoUploader"
                                        ref={inputVideoRef}
                                        multiple
                                        type="file"
                                        accept="video/*"
                                        onChange={UserUploadVideo}
                                        className={styles.fileDisplay}
                                    />
                                    {textUploadVideo}
                                </label>
                            </div>
                        </li>
                        {/* 動画スクリーンキャプチャ */}
                        {/* <li>
                            <div className={styles.formHelperText}>
                            </div>
                            <div className={styles.form}>
                                <CustomMediaRecorder setMediaRecorderVideoFile={SetMediaRecorderVideoFile}/>
                            </div>
                        </li> */}
                        {/*PDFファイル */}
                        {/* <li> */}
                        {/* <div className={styles.formHelperText}>PDFファイル</div>
                        <div className={styles.form}>
                        <label className={styles.uploadButton}>
                                    <input ref={inputSlideRef} id="inputSlideUploader"
                                    accept="application/pdf" multiple type="file"
                                    onChange={UserUploadSlide} className={styles.fileDisplay}/>アップロードするファイルを選択(100MBまで)
                                </label>
                        </div> */}
                        {/* </li> */}
                        {/* 画像サムネイルファイル */}
                        <li>
                            <div className={styles.formHelperText}>{t("サムネイル登録")}</div>
                            {visiblePreviewImage ? (
                                inputImageFile !== null && (
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.previewImage}>
                                            <img
                                                style={{ cursor: "pointer" }}
                                                alt="thumbnail"
                                                src={window.URL.createObjectURL(inputImageFile)}
                                                onClick={ClickPreviewImage}
                                            />
                                        </div>
                                        <p className={styles.previewText}>
                                            {t(
                                                "サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます"
                                            )}
                                        </p>
                                    </div>
                                )
                            ) : (
                                <div className={styles.form}>
                                    <label className={styles.selectThumnailButton}>
                                        <input
                                            id="browserPhotoUploader"
                                            ref={inputImageRef}
                                            multiple
                                            type="file"
                                            accept="image/*"
                                            onChange={UserUploadImage}
                                            className={styles.fileDisplay}
                                        />
                                        {textUploadImage}
                                    </label>
                                </div>
                            )}
                        </li>

                        {/* タイトル */}
                        <ThemeProvider theme={theme}>
                            <li>
                                <div className={styles.formHelperText}>
                                    {t("タイトル")}
                                    <div className={styles.descripionText}> {t("(必須)")}</div>
                                </div>
                                <div className={styles.form}>
                                    <TextField
                                        color="secondary"
                                        className={classes.title}
                                        id="videoName"
                                        variant="outlined"
                                        placeholder={String(t("タイトル"))}
                                        autoComplete="off"
                                        value={inputVideoName}
                                        onChange={ChangeTitle}
                                        error={isErrorTitleValidation}
                                        helperText={
                                            isErrorTitleValidation &&
                                            t(
                                                "全角40文字（半角80文字）以内で正しく入力してください"
                                            )
                                        }
                                    />
                                </div>
                            </li>

                            {/* <li>
                                <div className={styles.formHelperText}>
                                    アップロード動画の言語 <div className={styles.descripionText}>(必須)</div>
                                </div>
                                <div className={styles.form}>
                                    <span>
                                        <input id="sttLanguageJa" type="radio" name="sttLanguage" 
                                            value="ja-JP" onChange={changeInputLang} checked={inputLanguage==="ja-JP"}
                                        />
                                        <label htmlFor="sttLanguageJa" className={styles.formHelperTextLang}>
                                            日本語
                                        </label>
                                    </span>
                                    <span>
                                        <input id="sttLanguageEn" type="radio" name="sttLanguage"
                                            value="en-US" onChange={changeInputLang} checked={inputLanguage==="en-US"}
                                        />
                                        <label htmlFor="sttLanguageEn" className={styles.formHelperTextLang}>
                                            英語
                                        </label>
                                    </span>
                                    <span>
                                        <input id="sttLanguageZn" type="radio" name="sttLanguage" 
                                            value="zh-CN" onChange={changeInputLang} checked={inputLanguage==="zh-CN"}
                                        />
                                        <label htmlFor="sttLanguageZn" className={styles.formHelperTextLang}>
                                            中国語
                                        </label>
                                    </span>
                                    <span>
                                        <input id="sttLanguageVi" type="radio" name="sttLanguage" 
                                            value="vi-VN" onChange={changeInputLang} checked={inputLanguage==="vi-VN"}
                                        />
                                        <label htmlFor="sttLanguageVi" className={styles.formHelperTextLang}>
                                            ベトナム語
                                        </label>
                                    </span>
                                </div>
                            </li> */}

                            {/* プロフェッショナル */}
                            <li>
                                <div className={styles.formHelperText}>
                                    {t("プレゼンター")}
                                    <div className={styles.descripionText}> {t("(必須)")}</div>
                                </div>

                                <div className={styles.form}>
                                    <>
                                        <Select
                                            required
                                            color="secondary"
                                            id="demo-simple-select"
                                            variant="outlined"
                                            defaultValue="-1"
                                            onChange={UserInputVideoProfessional}
                                            value={inputVideoProfessional}
                                            className={classes.formSelect}
                                            MenuProps={{
                                                classes: { paper: classes.dropdownStyle },
                                                variant: "menu",
                                            }}
                                        >
                                            <MenuItem value={"-1"}>{t("選択なし")}</MenuItem>
                                            {professionals !== undefined &&
                                                professionals.length > 0 &&
                                                professionals.map(
                                                    (row) =>
                                                        row.roles.includes("PRESENTER") && (
                                                            <MenuItem
                                                                key={row.id}
                                                                value={row.id}
                                                                className={classes.menuItem}
                                                                style={{
                                                                    color:
                                                                        inputVideoProfessional ===
                                                                        row.id
                                                                            ? "var(--white)"
                                                                            : "rgba(255, 255, 255, 0.6)",
                                                                    background:
                                                                        inputVideoProfessional ===
                                                                        row.id
                                                                            ? "#35393F"
                                                                            : "",
                                                                }}
                                                            >
                                                                {row.fullName}
                                                            </MenuItem>
                                                        )
                                                )}
                                        </Select>
                                    </>
                                </div>
                            </li>
                            {/* グループ（モーダル表示） */}

                            <li className={styles.mb50}>
                                <div className={styles.formHelperTextLong}> {t("グループ")}</div>
                                <div className={styles.form}>
                                    <>
                                        <Select
                                            color="secondary"
                                            id="group-select"
                                            variant="outlined"
                                            onChange={UserInputVideoGroup}
                                            value={group ? group.map((group) => group.title) : []}
                                            multiple
                                            displayEmpty
                                            renderValue={(selected: any) => {
                                                if (selected.length === 0) {
                                                    return <p>{t("選択なし")}</p>;
                                                }

                                                return selected.join(", ");
                                            }}
                                            MenuProps={{
                                                getContentAnchorEl: null,
                                                anchorOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                                classes: {
                                                    paper: classes.dropdownStyle,
                                                },
                                            }}
                                            className={classes.formSelect}
                                            style={{
                                                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                            }}
                                        >
                                            <MenuItem disabled value="">
                                                <p>{t("選択なし")}</p>
                                            </MenuItem>
                                            {groupList &&
                                                groupList.map((row) => (
                                                    <MenuItem
                                                        key={row.id}
                                                        value={row.title}
                                                        className={classes.menuItem}
                                                        style={{
                                                            color: group
                                                                ? group.some(
                                                                      (group) =>
                                                                          group.title === row.title
                                                                  )
                                                                    ? "var(--white)"
                                                                    : "rgba(255, 255, 255, 0.6)"
                                                                : "rgba(255, 255, 255, 0.6)",
                                                            background: group
                                                                ? group.some(
                                                                      (group) =>
                                                                          group.title === row.title
                                                                  )
                                                                    ? "#35393F"
                                                                    : ""
                                                                : "",
                                                        }}
                                                    >
                                                        <Checkbox
                                                            style={{
                                                                color: "var(--white)",
                                                            }}
                                                            checked={
                                                                group.findIndex(
                                                                    (group) => group.id === row.id
                                                                ) >= 0
                                                            }
                                                        />
                                                        {row.title}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </>
                                </div>
                            </li>

                            {/* 要約 */}
                            <li>
                                <div className={styles.formHelperTextLong}>
                                    {t("内容")}
                                    <div className={styles.descripionText}>{t("(必須)")}</div>
                                </div>
                                <div className={styles.form}>
                                    <TextField
                                        color="secondary"
                                        id="description"
                                        onChange={ChangeDescription}
                                        className={classes.textField}
                                        multiline
                                        minRows={5}
                                        autoComplete="off"
                                        value={inputVideoDetail}
                                        variant="outlined"
                                        placeholder={String(t("内容を入力してください"))}
                                        error={isErrorDescriptionValidation}
                                        helperText={
                                            isErrorDescriptionValidation &&
                                            t(
                                                "全角300文字（半角600文字）以内で正しく入力してください"
                                            )
                                        }
                                    />
                                </div>
                            </li>

                            {/* 資料 */}
                            <li>
                                <div className={styles.formHelperTextLong}> {t("資料")}</div>
                                <div className={styles.formDocument}>
                                    <UploadDocument
                                        alreadyUploadDocumentList={[]}
                                        setIsSaved={setIsSaved}
                                        ChangeDocumentList={ChangeDocumentList}
                                        documentList={inputDocumentList}
                                        ChangeDocumentNameList={ChangeDocumentNameList}
                                        documentNameList={inputDocumentNameList}
                                        ErrorDocumentListLength={ErrorDocumentListLength}
                                        isShowAddDocIcon={true}
                                    />
                                </div>
                            </li>

                            <li className={styles.mb50}>
                                <div className={styles.formHelperTextLong}> {t("言語")}</div>
                                <div className={styles.formLang}>
                                    <>
                                        <Checkbox
                                            className={classes.checkBox}
                                            id="checkboxLanguageJa"
                                            color="secondary"
                                            checked={languageJa}
                                            onChange={handleChangeLanguageJa}
                                            disabled={inputLanguage === "ja-JP"}
                                            inputProps={{ "aria-label": "primary checkbox" }}
                                        />
                                        <span className={styles.formHelperTextLang}>
                                            {t("日本語")}
                                        </span>
                                        <Checkbox
                                            className={classes.checkBox}
                                            id="checkboxLanguageEn"
                                            color="secondary"
                                            checked={languageEn}
                                            onChange={handleChangeLanguageEn}
                                            disabled={inputLanguage === "en-US"}
                                            inputProps={{ "aria-label": "primary checkbox" }}
                                        />
                                        <span className={styles.formHelperTextLang}>
                                            {t("英語")}
                                        </span>
                                        <Checkbox
                                            className={classes.checkBox}
                                            id="checkboxLanguageZh"
                                            color="secondary"
                                            checked={languageZh}
                                            disabled={inputLanguage === "zh-CN"}
                                            onChange={handleChangeLanguageZh}
                                            inputProps={{ "aria-label": "primary checkbox" }}
                                        />
                                        <span className={styles.formHelperTextLang}>
                                            {t("中国語")}
                                        </span>
                                        <Checkbox
                                            className={classes.checkBox}
                                            id="checkboxLanguageVi"
                                            color="secondary"
                                            checked={languageVi}
                                            onChange={handleChangeLanguageVi}
                                            disabled={inputLanguage === "vi-VN"}
                                            inputProps={{ "aria-label": "primary checkbox" }}
                                        />
                                        <span className={styles.formHelperTextLang}>
                                            {t("ベトナム語")}
                                        </span>
                                    </>
                                </div>
                            </li>
                        </ThemeProvider>
                        {/* タグ（モーダル表示） */}
                        <li className={styles.mb50} style={{ marginBottom: "15px" }}>
                            <div className={styles.formHelperTextLong}> {t("タグ")}</div>
                            <div
                                className={styles.formTag}
                                style={{ marginBottom: "13px" }}
                                onMouseEnter={() => setMouseEnterInfo(true)}
                                onMouseLeave={() => setMouseEnterInfo(false)}
                            >
                                {!isMouseEnterInfo && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        alt={"More"}
                                        onClick={OpenTagSelectModal}
                                        src={
                                            require("../../../src/assets/image/MoreIcon.svg")
                                                .default
                                        }
                                    />
                                )}
                                {isMouseEnterInfo && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        alt={"More"}
                                        onClick={OpenTagSelectModal}
                                        src={
                                            require("../../../src/assets/image/MoreIcon_hover.svg")
                                                .default
                                        }
                                    />
                                )}
                            </div>
                            <div className={styles.tags}>
                                {tagList &&
                                    tagList.map((tag) => (
                                        <Chip
                                            label={tag}
                                            key={tag}
                                            color="secondary"
                                            style={{
                                                backgroundColor: "#24282E",
                                            }}
                                            size="medium"
                                            className={styles.tag}
                                            onDelete={handleDelete(tag)}
                                        />
                                    ))}
                            </div>
                        </li>

                        {/* 解像度選択 */}

                        <li>
                            <div className={styles.formHelperText}> {t("解像度")}</div>
                            <div
                                onClick={() => handleClickSetting(!openUploadVideoModal)}
                                style={{
                                    cursor: "pointer",
                                    marginLeft: IsDevice("desktop") ? "60px" : "",
                                }}
                            >
                                <img
                                    style={{
                                        cursor: "pointer",
                                    }}
                                    alt={"More"}
                                    src={require("../../../src/assets/image/MoreIcon.svg").default}
                                />
                            </div>
                            {openUploadVideoModal && (
                                <div className={styles.rootDiv}>
                                    <div className={styles.settingTitle}>
                                        {openCustom && (
                                            <div onClick={CloseCustom}>
                                                <ArrowBackIos />
                                            </div>
                                        )}
                                        <PuiTypography size={14}>
                                            {openCustom ? t("カスタム") : t("動画設定")}
                                        </PuiTypography>
                                    </div>
                                    {openCustom ? (
                                        <CustomTimelineSetting
                                            selectResolution={selectResolution}
                                            selectvideoFrameRate={selectvideoFrameRate}
                                            selectBitRate={selectBitRate}
                                            openVideoResolutionSelect={openVideoResolutionSelect}
                                            setOpenVideoResolutionSelect={
                                                setOpenVideoResolutionSelect
                                            }
                                            openVideoFramerateSelect={openVideoFramerateSelect}
                                            setOpenVideoFramerateSelect={
                                                setOpenVideoFramerateSelect
                                            }
                                            openVideoBitrateSelect={openVideoBitrateSelect}
                                            setOpenVideoBitrateSelect={setOpenVideoBitrateSelect}
                                        />
                                    ) : (
                                        <>
                                            <div className={styles.settingButton}>
                                                {RESOLUTION.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        className={
                                                            !isCustom && resolutionType === item
                                                                ? styles.activeButton
                                                                : styles.button
                                                        }
                                                        onClick={() =>
                                                            ChangeResolution(
                                                                Bitrate[index],
                                                                Resolution[index],
                                                                FrameRate[index],
                                                                item
                                                            )
                                                        }
                                                    >
                                                        {!isCustom && resolutionType === item && (
                                                            <Check />
                                                        )}
                                                        <PuiTypography size={14}>
                                                            {item}
                                                        </PuiTypography>
                                                    </div>
                                                ))}
                                            </div>
                                            <div
                                                className={
                                                    resolutionType === t("カスタム")
                                                        ? styles.activeCustom
                                                        : styles.custom
                                                }
                                                onClick={() =>
                                                    isCustom
                                                        ? ChangeResolution(
                                                              String(videoBitrate),
                                                              `${videoWidth}×${videoHeight}`,
                                                              String(videoFramerate),
                                                              t("カスタム")
                                                          )
                                                        : ChangeResolution(
                                                              Bitrate[1],
                                                              Resolution[1],
                                                              FrameRate[1],
                                                              t("カスタム")
                                                          )
                                                }
                                                style={{
                                                    border: isCustom
                                                        ? "1px solid #FFFFFFCC"
                                                        : "none",
                                                }}
                                            >
                                                {isCustom && <Check />}
                                                <PuiTypography size={14}>
                                                    {t("カスタム")}
                                                </PuiTypography>
                                            </div>
                                        </>
                                    )}
                                    <div
                                        className={styles.modalBg}
                                        onClick={() => {
                                            setOpenUploadVideoModal(false);
                                        }}
                                    ></div>
                                </div>
                            )}
                        </li>

                        {/* ビデオ追加ボタン */}

                        <div className={styles.btnDiv}>
                            {isReadyToUpdate ? (
                                <Button
                                    disabled={isReadyToUpdate}
                                    type="submit"
                                    onClick={UploadVideo}
                                    color="secondary"
                                    className={styles.updateButton}
                                    style={{
                                        color: "var(--loading-bg)",
                                        fontSize: "16px",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        backgroundColor: "var(--button-bg)",
                                    }}
                                >
                                    {t("登録")}
                                </Button>
                            ) : (
                                <Button
                                    type="submit"
                                    onClick={UploadVideo}
                                    color="secondary"
                                    className={styles.updateButton}
                                    style={{
                                        color: "white",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        backgroundColor: "var(--studio-btn-bg)",
                                    }}
                                >
                                    {t("登録")}
                                </Button>
                            )}
                        </div>
                    </form>
                </FormControl>
            </ul>

            {/* タグ選択モーダル */}
            <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                <SelectTag
                    in={isOpenTagSelectModal}
                    onClose={CloseTagSelectModal}
                    tagList={tagList}
                    setTagList={setTagList}
                    setIsSaved={setIsSaved}
                />
            </Modal>

            {/* グループ選択モーダル */}
            <Modal open={isOpenGroupSelectModal} onClose={CloseGroupSelectModal}>
                <SelectGroup
                    visibleModal={isOpenGroupSelectModal}
                    onClose={CloseGroupSelectModal}
                    targetName={inputVideoFileName}
                    userGroup={group}
                    SetGroupList={SetVideoGroup}
                    SetIsSaved={setIsSaved}
                />
            </Modal>

            <PuiMessage
                open={isLimitInputFileSize}
                onClose={CloseLimitInputFileBar}
                type="error"
                title={t("1GB以上のファイルはアップロードできません")}
                duration={5000}
            />

            {/* アップロードイメージサムネイルサイズチェック */}
            <PuiMessage
                open={isLimitInputImageSize}
                onClose={CloseLimitInputImageBar}
                type="error"
                title={t("10MB以上の画像はアップロードできません")}
                duration={5000}
            />

            <PuiMessage
                open={isErrorInputSize}
                type="error"
                title={t("正しいファイルを選択してください")}
                duration={5000}
                onClose={CloseErrorInputBar}
            />
        </div>
    );
}
